import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const AddVaultPage = lazy(() => import('./AddVaultPage'));

const AddVaultConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.AllUsers,
  routes: [
    {
      path: 'add-vault/:token',
      element: <AddVaultPage />,
    },
  ],
};

export default AddVaultConfig;
